// @module Cart
define('Cart.Detailed.View.LimitQty', [
  'Cart.Detailed.View',
  'GlobalViews.Message.View',
  'LimitItemQuantity.Helper',
  'jQuery',
  'underscore'
], function CartDetailedViewLimitQty(
  CartDetailedView,
  GlobalViewsMessageView,
  Helper,
  jQuery,
  _
) {
  'use strict';

  // @class Cart.Detailed.View This is the Shopping Cart view @extends Backbone.View
  return _.extend(CartDetailedView.prototype, {

    updateItemQuantity: _.wrap(CartDetailedView.prototype.updateItemQuantity, function updateItemQuantityWrap(fn, e) {
      var event = _.toArray(arguments).slice(1);
      var form;
      var options;
      var internalid;
      var line;
      var input;
      var quantity;
      var lineItem;
      var errorInsufficientAmount;
      var errorMessage;
      var itemValidation;
      var configuration = this.options.application.configuration;
      var enabledForCart = configuration && configuration.limitItemQuantity ? configuration.limitItemQuantity.enabledForCart : false;
      if (enabledForCart) {
        form = jQuery(e.target).closest('form');
        options = form.serializeObject();
        internalid = options.internalid;
        line = this.model.get('lines').get(internalid);
        input = form.find('[name="quantity"]');
        quantity = parseInt(input.val(), 0);
        lineItem = line.get('item');
        errorInsufficientAmount = Helper.insufficientAmount;
        itemValidation = Helper.validateItem({
          quantityavailable: lineItem.get('quantityavailable'),
          isbackorderable: lineItem.get('isbackorderable')
        }, quantity);
        if (!itemValidation.isValid) {
          e.preventDefault();
          input.val(line.get('quantity'));
          errorMessage = errorInsufficientAmount.errorMessage.replace('[QTY]', lineItem.get('quantityavailable'));
          this.showQtyErrorMessage(errorMessage, input);
        } else {
          fn.apply(this, event);
        }
      } else {
        fn.apply(this, event);
      }
    }),

    showQtyErrorMessage: function showQtyErrorMessage(errorInsufficientAmount, input) {
      var form = jQuery(input).closest('form');
      var placeHolder = jQuery(form).find('[data-type="alert-placeholder"]');
      var errorMessageItems = new GlobalViewsMessageView({
        message: errorInsufficientAmount,
        type: 'error',
        closable: true
      });
      this.$(placeHolder).empty().append(errorMessageItems.render().$el.html());
    }
  });
});
